/**
 * @author johan.magnusson@svenskaspel.se (Johan Magnusson)
 */

import PropTypes from 'prop-types';
import './../../stylesheets/sausage.less';

/**
 * Sausage, or circle graph, is used to present data in percentage.
 */
function Sausage({
  animate,
  bgColor,
  children,
  className,
  color,
  percent,
  sharpEdges,
  smallSausage,
  strokeWidth,
  ...props
}) {
  const classes = ['sausage'];

  if (className) {
    classes.push(className);
  }

  if (animate) {
    classes.push('animate-sausage');
  }
  if (smallSausage) {
    classes.push('sausage-small');
  } else {
    classes.push('sausage-default');
  }
  const getDashOffsetFromPercent = (percent, sharpEdges, strokeWidth) => {
    percent = parseInt(percent, 10);
    percent = sharpEdges ? percent : percent + percent / 100;
    strokeWidth = strokeWidth ? parseInt(strokeWidth, 10) : 6;
    const dashOffset = 283;
    const calculatedOffset =
      dashOffset - Math.ceil(dashOffset * (parseInt(percent, 10) * 0.01));
    if (!sharpEdges && percent !== 0) {
      return calculatedOffset + strokeWidth;
    }
    return calculatedOffset;
  };
  return (
    <div className={classes.join(' ')} {...props}>
      <svg className="sausage-svg" viewBox="0 0 100 100">
        <circle className="sausage-circle"
          cx="50" cy="50" fill={bgColor}
          r="45"
          stroke={color}
          strokeDashoffset={getDashOffsetFromPercent(percent, sharpEdges, strokeWidth)}
          strokeLinecap={sharpEdges ? '' : 'round'}
          strokeWidth={strokeWidth}
          transform="rotate(-90 50 50)"/>
      </svg>
      <span className="sausage-content">{children}</span>
    </div>
  );
}

Sausage.propTypes = {
  animate: PropTypes.bool,
  /**
   * Select background-color of indicator
   */
  bgColor: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['red', 'blue', 'green'])
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * Select color of indicator
   */
  color: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['red', 'blue', 'green'])
  ]),
  /**
   * How many percent the stroke will fill
   */
  percent: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([20, 50, 80])
  ]),
  /**
   * Select if stroke wants to be sharpened.
   */
  sharpEdges: PropTypes.bool,
  /**
   * Select if you want a mini-version
   */
  smallSausage: PropTypes.bool,
  /**
   * Set stroke width
   */
  strokeWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.oneOf(['4', '6', '8'])
  ])
};

Sausage.defaultProps = {
  animate: false,
  bgColor: 'transparent',
  color: '#0066a4',
  sharpEdges: false,
  smallSausage: false,
  strokeWidth: '6'
};

export default Sausage;
